module.exports = __webpack_public_path__ + "img/hopways.76650c6b.webp";